import React, { useRef } from 'react';
import styled from 'styled-components';
import { hideVisually } from 'polished';
import { ClickableElement } from '@cko/primitives';
import { IconActionCopy } from '@cko/icons';
import { TruncateWord } from '../TruncateWord';
const Button = styled(ClickableElement) `
  --base-icon-primary-alt: var(--action-icon-primary);
  align-items: center;
  cursor: pointer;
  display: flex;
  max-width: 100%;
  padding: var(--layout-sandgrain);

  svg {
    flex-shrink: 0; // Prevents the element from shrinking
    margin-left: var(--layout-seed);
    vertical-align: text-bottom;
  }
`;
const HiddenCopyValue = styled.textarea `
  ${hideVisually()};
`;
export const CopyToClipboard = (props) => {
    const { text, value = text, rightElement = React.createElement(IconActionCopy, null), ...rest } = props;
    const copyRef = useRef(null);
    const copy = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (copyRef.current) {
            copyRef.current.select();
            const refText = copyRef.current?.textContent ?? '';
            window.navigator.clipboard.writeText(refText.trim());
        }
    };
    return (React.createElement(Button, { onClick: copy, ...rest, title: "Click to copy", text: text },
        React.createElement(HiddenCopyValue, { ref: copyRef, value: value, readOnly: true }),
        React.createElement(TruncateWord, { color: "var(--base-text-primary)" }, text),
        rightElement));
};
